import { ApiService } from '../../services/apiService';
import { notificationActions } from '../notification/actions';
import { syncFailed } from '../notification/types';
import { ApplicationState } from '..';

import {
  Department,
  GET_USER_INFO,
  SET_SELECTED_DEPARTMENT,
  SET_USERNAME,
} from './types';
import { authActions } from '../auth/actions';

function setUsername(username: string) {
  return (dispatch: any) => {
    dispatch({
      type: SET_USERNAME,
      username,
    });
  };
}

function setSelectedDepartment(department?: Department) {
  return {
    type: SET_SELECTED_DEPARTMENT,
    department,
  };
}
function getUserInfo() {
  return async (dispatch: any, getState: () => ApplicationState) => {
    try {
      await dispatch(authActions.refreshTokenIfExpired());
      const response = await ApiService.getDetailedUserInfo();

      const detailedUserInfo = response.data;

      const departments = detailedUserInfo.departments.filter((department) => {
        const result: Department = {
          id: department.id,
          name: department.name,
          organizationId: department.organizationId,
          organizationName: department.organizationName,
          stackNumbering: department.stackNumbering,
        };
        return result;
      });

      dispatch({
        type: GET_USER_INFO,
        organizationRelations: detailedUserInfo.organizationRelations,
        departmentRelations: detailedUserInfo.departmentRelations,
        departments: departments,
      });
    } catch {
      return dispatch(notificationActions.addMessage(syncFailed));
    }

    const state = getState();
    const departments = state.user.departments ?? [];
    const selectedDepartment = departments.find(
      (department) => department.id === state.user.selectedDepartment?.id,
    );

    dispatch(setSelectedDepartment(selectedDepartment ?? departments[0]));
  };
}

export const userActions = {
  setUsername,
  getUserInfo,
  setSelectedDepartment,
};
